import React from 'react'

import ErrorIcon from '@material-ui/icons/Error'
import { makeStyles } from '@material-ui/core/styles'

import t from '../../../translations'

export const SAVE_ERROR_ID = 'blad-zapisu'

// Błąd zapisu w układzie strony, nad przyciskiem wysyłania (zamiast toastu w rogu, który na telefonie zasłaniał
// przycisk w 100% przez 5 s). Kolory jak komunikat błędu w FlashToasts.js: tło #FFC107, ramka 2 px #A16207
// (4,92:1 wobec białej strony), tekst #0A0A0A (12,1:1 na żółtym); padding SnackbarContent pomniejszony o ramkę.
// Nie znika sam — czyści go dopiero kolejna próba wysłania (saveAnswers.js).
const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.typography.body2,
    display: 'flex',
    alignItems: 'flex-start',
    backgroundColor: '#FFC107',
    color: '#0A0A0A',
    border: '2px solid #A16207',
    borderRadius: theme.shape.borderRadius,
    padding: '4px 14px',
    marginBottom: theme.spacing(2),
  },
  icon: {
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.spacing(1),
    marginTop: 8,
    flexShrink: 0,
  },
  message: {
    padding: '8px 0',
  },
}))

const SaveErrorMessage = () => {
  const classes = useStyles()

  return (
    <div id={SAVE_ERROR_ID} role={'alert'} className={classes.root}>
      <ErrorIcon className={classes.icon} />
      <div className={classes.message}>
        {t.pollView.error}
      </div>
    </div>
  )
}

export default SaveErrorMessage
